import {LOCALE_ID, NgModule} from '@angular/core';
import {DecimalPipe, registerLocaleData} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import localeDa from '@angular/common/locales/da';

import {FlexLayoutModule} from "@angular/flex-layout";

import {CookieService} from "ngx-cookie-service";

import {ErrorInterceptor} from "./core/interceptors";
import {RandomBackgroundDirective} from './core/directives';
import {CustomersModule} from './customers/customers.module';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {SignInComponent} from './components/sign-in/sign-in.component';
import {DashboardComponent} from './components/dashboard/dashboard.component';

import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {ThemeSelectorComponent} from "./theme-toggle.component";
import {MaterialModule} from "./material.module";
import {MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS} from "@angular/material/button-toggle";
import {MAT_CHECKBOX_DEFAULT_OPTIONS} from "@angular/material/checkbox";
import {MAT_RADIO_DEFAULT_OPTIONS} from "@angular/material/radio";
import {MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS} from "@angular/material/slide-toggle";
import {MAT_CARD_CONFIG} from "@angular/material/card";
import {MAT_DIALOG_DEFAULT_OPTIONS} from "@angular/material/dialog";
import {NoopScrollStrategy} from "@angular/cdk/overlay";

const options: any = {
  color: 'primary',
};
registerLocaleData(localeDa, 'da');

@NgModule({
  declarations: [
    AppComponent,
    SignInComponent,
    DashboardComponent,
    RandomBackgroundDirective,
    ThemeSelectorComponent
  ],
  bootstrap: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    MaterialModule,
    CustomersModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'da' },
    CookieService,
    DecimalPipe,
    { provide: MAT_CHECKBOX_DEFAULT_OPTIONS, useValue: options },
    { provide: MAT_RADIO_DEFAULT_OPTIONS, useValue: options },
    { provide: MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS, useValue: options },
    { provide: MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS, useValue: options },
    { provide: MAT_CARD_CONFIG, useValue: {appearance: 'outlined'}},
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        panelClass: 'dialog',
        scrollStrategy: new NoopScrollStrategy(),
        autoFocus: false,
        hasBackdrop: true,
        disableClose: true,
        closeOnNavigation: false,
        maxWidth: 'unset',
        minWidth: 'unset',
      }
    },
    provideHttpClient(withInterceptorsFromDi()),
  ]
})
export class AppModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, `${location.origin}/assets/i18n/`);
}
